/**
 * Markdown Parser Utility
 * Converts markdown files from data/split-issues/ into structured JSON
 * for interactive content presentation in the chatbot.
 *
 * Uses fetch to load markdown files from the public folder.
 */

const BASE_PATH = '/data/split-issues';

// Map of issue IDs to their markdown file paths
const issueFilePaths = {
  'EMO_001': 'EMO_001.md',
  'EMO_002': 'EMO_002.md',
  'EMO_003': 'EMO_003.md',
  'EMO_004': 'EMO_004.md',
  'EMO_005': 'EMO_005.md',
  'EMO_006': 'EMO_006.md',
  'EMO_007': 'EMO_007.md',
  'EMO_008': 'EMO_008.md',
  'EMO_009': 'EMO_009.md',
  'EMO_010': 'EMO_010.md',
  'EMO_011': 'EMO_011.md',
  'EMO_012': 'EMO_012.md',
  'EMO_013': 'EMO_013.md',
  'EMO_014': 'EMO_014.md',
  'EMO_015': 'EMO_015.md',
  'EMO_016': 'EMO_016.md',
  'EMO_017': 'EMO_017.md',
  'EMO_018': 'EMO_018.md',
  'EMO_019': 'EMO_019.md',
  'EMO_020': 'EMO_020.md',
  'EMO_021': 'EMO_021.md',
  'EMO_022': 'EMO_022.md',
  'EMO_023': 'EMO_023.md',
  'EMO_024': 'EMO_024.md',
  'EMO_025': 'EMO_025.md',
  'EMO_026': 'EMO_026.md',
  'EMO_027': 'EMO_027.md',
  'MYS_001': 'MYS_001.md',
  'MYS_002': 'MYS_002.md',
  'MYS_003': 'MYS_003.md',
  'MYS_004': 'MYS_004.md',
  'MYS_005': 'MYS_005.md',
  'MYS_006': 'MYS_006.md',
  'MYS_007': 'MYS_007.md',
  'MYS_008': 'MYS_008.md',
  'MYS_009': 'MYS_009.md',
  'MYS_010': 'MYS_010.md',
  'MYS_011': 'MYS_011.md',
  'MYS_012': 'MYS_012.md',
  'MYS_013': 'MYS_013.md',
  'MYS_014': 'MYS_014.md',
  'MYS_015': 'MYS_015.md',
  'MYS_016': 'MYS_016.md',
  'MYS_017': 'MYS_017.md',
  'MYS_018': 'MYS_018.md',
  'MYS_019': 'MYS_019.md',
  'MYS_020': 'MYS_020.md',
  'MYS_021': 'MYS_021.md',
  'MYS_022': 'MYS_022.md',
  'MYS_023': 'MYS_023.md',
  'MYS_024': 'MYS_024.md',
  'REL_001': 'REL_001.md',
  'REL_002': 'REL_002.md',
  'REL_003': 'REL_003.md',
  'REL_004': 'REL_004.md',
  'REL_005': 'REL_005.md',
  'REL_006': 'REL_006.md',
  'REL_007': 'REL_007.md',
  'REL_008': 'REL_008.md',
  'REL_009': 'REL_009.md',
  'REL_010': 'REL_010.md',
  'REL_011': 'REL_011.md',
  'REL_012': 'REL_012.md',
  'REL_013': 'REL_013.md',
  'REL_014': 'REL_014.md',
  'REL_015': 'REL_015.md',
  'REL_016': 'REL_016.md',
  'REL_017': 'REL_017.md',
  'REL_018': 'REL_018.md',
  'REL_019': 'REL_019.md',
  'REL_020': 'REL_020.md',
  'REL_021': 'REL_021.md',
  'REL_022': 'REL_022.md',
  'REL_023': 'REL_023.md',
  'REL_024': 'REL_024.md',
  'REL_025': 'REL_025.md',
  'REL_026': 'REL_026.md',
  'REL_027': 'REL_027.md',
  'UND_001': 'UND_001.md',
  'UND_002': 'UND_002.md',
  'UND_003': 'UND_003.md',
  'UND_004': 'UND_004.md',
  'UND_005': 'UND_005.md',
  'UND_006': 'UND_006.md',
  'UND_007': 'UND_007.md',
  'UND_008': 'UND_008.md',
  'UND_009': 'UND_009.md',
  'UND_010': 'UND_010.md',
  'UND_011': 'UND_011.md',
  'UND_012': 'UND_012.md',
  'UND_013': 'UND_013.md',
  'UND_014': 'UND_014.md',
  'UND_015': 'UND_015.md',
  'UND_016': 'UND_016.md',
  'UND_017': 'UND_017.md',
  'UND_018': 'UND_018.md',
  'UND_019': 'UND_019.md',
  'UND_020': 'UND_020.md',
  'UND_021': 'UND_021.md',
  'UND_022': 'UND_022.md',
  'UND_023': 'UND_023.md',
  'UND_024': 'UND_024.md',
  'UND_025': 'UND_025.md',
  'UND_026': 'UND_026.md',
  'UND_027': 'UND_027.md',
  'UND_028': 'UND_028.md',
  'UND_029': 'UND_029.md',
  'UND_030': 'UND_030.md',
  'UND_031': 'UND_031.md',
  'UND_032': 'UND_032.md',
};

// Cache for loaded markdown content
const markdownCache = {};

/**
 * Parse a markdown file into structured sections
 * @param {string} markdownContent - Raw markdown content
 * @param {string} issueId - The issue ID (e.g., 'EMO-001')
 * @returns {Object} Parsed structured data
 */
export const parseMarkdown = (markdownContent, issueId) => {
  const lines = markdownContent.split('\n');
  const result = {
    id: issueId,
    title: '',
    sections: []
  };

  let currentSection = null;
  let currentContent = [];
  let inIntervention = false;
  let sectionIndex = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    // Extract title from first h2
    if (line.startsWith('## ') && !result.title) {
      const titleMatch = line.match(/## (.+?): (.+?) \*\*\*/);
      if (titleMatch) {
        result.title = titleMatch[2];
      }
      continue;
    }

    // Detect main sections (both h3 and h4 headers)
    if (line.startsWith('### ') || line.startsWith('#### ')) {
      // Save previous section if exists
      if (currentSection) {
        // If there are substeps, the substeps are the content - don't show raw text
        if (currentSection.substeps && currentSection.substeps.length > 0) {
          currentSection.content = '';
        } else {
          currentSection.content = currentContent.join('\n').trim();
        }
        result.sections.push(currentSection);
      }

      // Handle both ### and #### headers
      const isH4 = line.startsWith('#### ');
      const sectionTitle = isH4 ? line.replace('#### ', '').trim() : line.replace('### ', '').trim();
      currentContent = [];
      sectionIndex++;
      
      // Extract substeps for this section (if h4)
      const substeps = isH4 ? extractSubsteps(lines, i) : [];

      // Determine section type and create new section
      currentSection = {
        id: `section-${sectionIndex - 1}`,
        title: sectionTitle,
        type: determineSectionType(sectionTitle),
        isInterventionStep: isH4, // h4 headers are intervention steps
        content: '',
        substeps: substeps,
        elements: extractInteractiveElements(lines, i, sectionIndex - 1),
        toolReferences: extractToolReferences(lines, i)
      };

      // Mark when we enter Intervention section
      if (sectionTitle.toLowerCase().includes('intervention')) {
        inIntervention = true;
      }
    } else if (currentSection) {
      currentContent.push(line);
    }
  }

  // Save last section
  if (currentSection) {
    const rawContent = currentContent.join('\n').trim();
    
    // If there are substeps, the substeps are the content - don't show raw text
    // The substeps will be rendered separately in the UI
    if (currentSection.substeps && currentSection.substeps.length > 0) {
      // For intervention steps with substeps, content is empty since substeps replace it
      currentSection.content = '';
    } else {
      currentSection.content = rawContent;
    }
    
    result.sections.push(currentSection);
  }

  return result;
};

/**
 * Determine the type of section based on its title
 */
const determineSectionType = (title) => {
  const lowerTitle = title.toLowerCase();
  
  if (lowerTitle.includes('what is this really about')) {
    return 'explanation';
  }
  if (lowerTitle.includes('real life example')) {
    return 'example';
  }
  if (lowerTitle.includes('intervention')) {
    return 'intervention';
  }
  if (lowerTitle.includes('resolution')) {
    return 'resolution';
  }
  if (lowerTitle.includes('book connections')) {
    return 'references';
  }
  if (lowerTitle.match(/^\d+\.\s/)) {
    return 'interactive';
  }
  
  return 'general';
};

/**
 * Extract interactive elements (reflections, ratings, checkboxes) from section content
 */
const extractInteractiveElements = (lines, startIndex, sectionIndex) => {
  const elements = [];
  let elementId = 0;

  // Collect lines for this section
  let sectionLines = [];
  for (let i = startIndex + 1; i < lines.length; i++) {
    if (lines[i].startsWith('### ') || (i > startIndex + 1 && lines[i].startsWith('## '))) {
      break;
    }
    sectionLines.push(lines[i]);
  }

  const sectionText = sectionLines.join('\n');

  // Extract reflection questions (lines starting with **Ask yourself:** or similar)
  const reflectionMatches = sectionText.match(/\*\*Ask yourself:.*?\*\*[\s\S]*?(?=\*\*|$)/g);
  if (reflectionMatches) {
    reflectionMatches.forEach((match, idx) => {
      const prompt = match.replace(/\*\*/g, '').replace(/Ask yourself:/i, '').trim();
      if (prompt) {
        elements.push({
          id: `element-${sectionIndex}-${elementId++}`,
          type: 'reflection',
          prompt: prompt,
          placeholder: 'Write your thoughts here...'
        });
      }
    });
  }

  // Extract rating scales (lines containing "scale of 1-10")
  const ratingMatches = sectionText.match(/On the scale of 1-10.*?(?=\.|$)/gi);
  if (ratingMatches) {
    ratingMatches.forEach((match) => {
      elements.push({
        id: `element-${sectionIndex}-${elementId++}`,
        type: 'rating',
        prompt: match.trim(),
        min: 1,
        max: 10,
        defaultValue: 5
      });
    });
  }

  // If no specific elements found but section is interactive, add a general reflection
  if (elements.length === 0 && sectionText.length > 50) {
    elements.push({
      id: `element-${sectionIndex}-${elementId++}`,
      type: 'reflection',
      prompt: 'Take a moment to reflect on this section. What insights come up for you?',
      placeholder: 'Your reflections...'
    });
  }

  // Add completion checkbox for interactive sections
  if (sectionText.length > 100) {
    elements.push({
      id: `element-${sectionIndex}-${elementId++}`,
      type: 'checkbox',
      label: 'I have completed this section'
    });
  }

  return elements;
};

/**
 * Extract substeps from intervention step sections
 * Substeps are bold text items (**text**) within an intervention step
 */
const extractSubsteps = (lines, startIndex) => {
  const substeps = [];
  
  // Collect lines for this section until we hit another header
  let sectionLines = [];
  for (let i = startIndex + 1; i < lines.length; i++) {
    if (lines[i].startsWith('### ') || lines[i].startsWith('#### ') || (i > startIndex + 1 && lines[i].startsWith('## '))) {
      break;
    }
    if (lines[i].trim()) {
      sectionLines.push(lines[i]);
    }
  }
  
  // Find all bold text items (**text**) - these are substeps
  const sectionText = sectionLines.join('\n');
  const boldPattern = /\*\*([^*]+)\*\*/g;
  let match;
  let substepIndex = 0;
  
  while ((match = boldPattern.exec(sectionText)) !== null) {
    const substepTitle = match[1].trim();
    // Find the content after this bold text until the next bold text or end
    const matchStart = match.index + match[0].length;
    const nextMatch = sectionText.substring(matchStart).search(/\*\*[^*]+\*\*/);
    const substepContent = nextMatch === -1
      ? sectionText.substring(matchStart).trim()
      : sectionText.substring(matchStart, matchStart + nextMatch).trim();
    
    substeps.push({
      id: `substep-${substepIndex++}`,
      title: substepTitle,
      content: substepContent
    });
  }
  
  return substeps;
};

/**
 * Extract tool references from section content (e.g., [T-002: First-Aid Kit])
 */
const extractToolReferences = (lines, startIndex) => {
  const tools = [];
  
  // Collect lines for this section
  let sectionLines = [];
  for (let i = startIndex + 1; i < lines.length; i++) {
    if (lines[i].startsWith('### ') || (i > startIndex + 1 && lines[i].startsWith('## '))) {
      break;
    }
    sectionLines.push(lines[i]);
  }

  const sectionText = sectionLines.join('\n');
  
  // Find tool references like [T-002: First-Aid Kit]
  const toolMatches = sectionText.match(/\[T-\d+:[^\]]+\]/g);
  if (toolMatches) {
    toolMatches.forEach((match) => {
      const toolIdMatch = match.match(/T-(\d+):(.+)/);
      if (toolIdMatch) {
        tools.push({
          id: `T-${toolIdMatch[1]}`,
          name: toolIdMatch[2].trim()
        });
      }
    });
  }

  return tools;
};

/**
 * Fetch markdown content for a specific issue
 * @param {string} issueId - The issue ID (e.g., 'EMO_001' or 'EMO-001')
 * @returns {Promise<string>} Markdown content
 */
const fetchMarkdownContent = async (issueId) => {
  // Check cache first
  if (markdownCache[issueId]) {
    return markdownCache[issueId];
  }

  // Convert underscores to hyphens (EMO_001 -> EMO-001)
  const normalizedId = issueId;//.replace(/_/g, '-');
  
  const filePath = issueFilePaths[normalizedId];
  if (!filePath) {
    console.error(`Issue not found: ${issueId} (normalized: ${normalizedId})`);
    return null;
  }

  try {
    const response = await fetch(`${BASE_PATH}/${filePath}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${filePath}: ${response.status}`);
    }
    const markdown = await response.text();
    markdownCache[issueId] = markdown;
    return markdown;
  } catch (error) {
    console.error(`Error loading issue ${issueId}:`, error);
    return null;
  }
};

/**
 * Get parsed issue data by ID (async)
 * @param {string} issueId - The issue ID (e.g., 'EMO-001')
 * @returns {Promise<Object>} Parsed issue data
 */
export const getIssueData = async (issueId) => {
  const markdown = await fetchMarkdownContent(issueId);
  if (!markdown) {
    return null;
  }
  return parseMarkdown(markdown, issueId);
};

/**
 * Get all available issue IDs
 */
export const getAllIssueIds = () => {
  return Object.keys(issueFilePaths);
};

/**
 * Preload all issue markdown files
 * @returns {Promise<void>}
 */
export const preloadAllIssues = async () => {
  const promises = Object.keys(issueFilePaths).map(issueId =>
    fetchMarkdownContent(issueId)
  );
  await Promise.all(promises);
};

export default {
  parseMarkdown,
  getIssueData,
  getAllIssueIds,
  preloadAllIssues
};
